import { Context } from './types';

export const setLoading = (): Partial<Context> => ({ loading: true });
export const resetLoading = (): Partial<Context> => ({ loading: false });
